import React, { useState, useContext, useEffect } from 'react';
import '../styles/CreateParty.css';
import AuthContext, { CacheContext } from '../contexts/index';
import Party from '../entities/party';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import { getPartyById, updateParty } from '../apiCalls/partyAPI';
import { NotificationContext } from '../contexts/NotificationContext';
import { useNavigate, useParams } from 'react-router-dom';


function UpdateParty() {
    const visible = { visibility: 'visible' };
    const hidden = { visibility: 'hidden' };
    const [modalShow, setModalShow] = useState(hidden);
    const { user } = useContext(AuthContext);
    const { cachedParties, setCachedParties, activeParty, setActiveParty } = useContext(CacheContext);
    const { showToast } = useContext(NotificationContext);
    const { partyId } = useParams();
    const [partyName, setPartyName] = useState();
    const [guestList, setGuestList] = useState([]);
    const [guest, setGuest] = useState();
    const navigate = useNavigate();


    useEffect(() => {
        if (!activeParty) {
            const party = cachedParties.find(party => party.id === partyId);
            if (party) {
                setActiveParty(party);
            } else {
                getPartyById(partyId, user.credential)
                    .then(party => {
                        setActiveParty(party); 
                        setPartyName(party.partyName);
                        setGuestList(party.guestList);
                        setCachedParties([...cachedParties, party]);
                    })
                    .catch(error => { if (!error.response) { showToast('Unable to reach server. Please try again.', 'error'); } else { showToast('Failed to load party. Please try again.', 'error'); } });
            }
        }else{
            setPartyName(activeParty.partyName);
            setGuestList(activeParty.guestList);
        }

    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();
        setModalShow(visible);
        updateParty(new Party(activeParty.id, user.email, partyName, guestList), user.credential)
            .then(()=>setModalShow(hidden))
            .finally(() => navigate('/'))
            .catch(err => { if (!err.response) { showToast('Unable to reach server. Please try again.', 'error'); } else { showToast('Failed to save changes. Please try again.', 'error'); } });

    }

    const addGuest = () => {
        setGuestList([...guestList, guest]);
        setGuest("");
    }

    const removeGuest = (guest) => {
        setGuestList(guestList.filter(g => g !== guest));
    }

    return (
        <div className="container">
                   <span className="loader" style={modalShow}></span>
            <h1>Update Your Party</h1>
            <div className='row'>
                <div className="col-md-6">
                    <form id="createPartyForm" onSubmit={handleSubmit}>

                        <div className="form-group" >
                            <label htmlFor="">Party Name</label>
                            <input type="text" name="partyName" value={partyName} className="form-control" data-testid="partyName" onChange={(e) => setPartyName(e.target.value)} />
                        </div>

                        <div className="guest-list-card-wrapper">
                            <div className="guest-list-header">
                                <h3>Add Emails to Guest List</h3>
                            </div>

                            <div className="guest-input-row">
                                <input
                                    type="text"
                                    name="guestListTextbox"
                                    className="form-control guest-email-input"
                                    placeholder='myguest@email.com'
                                    value={guest}
                                    id="guestListTextbox"
                                    data-testid="guestListTextbox"
                                    onChange={(e) => setGuest(e.target.value.toLowerCase())}
                                />
                                <button
                                    onClick={() => addGuest()}
                                    disabled={!guest}
                                    className="guest-add-icon-btn"
                                    title="Add guest"
                                >
                                    <AddIcon sx={{ fontSize: '1.5rem' }} />
                                </button>
                            </div>

                            {guestList.length > 0 && (
                                <div className="guest-items-container">
                                    {guestList.map((guestItem, i) => (
                                        <div className="guest-item" key={i}>
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control guest-email-display"
                                                value={guestItem}
                                                id={`guestListItem${i}`}
                                                data-testid={`guestListItem${i}`}
                                            />
                                            <button
                                                onClick={() => removeGuest(guestItem)}
                                                className="guest-delete-icon-btn"
                                                title="Remove guest"
                                            >
                                                <DeleteIcon sx={{ fontSize: '1.5rem' }} />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className="guest-list-footer">
                                <label>You can always add or remove guests later...</label>
                            </div>
                        </div>

                        <div className="form-group">
                            <button type="submit" disabled={!partyName} className="btn btn-success" data-testid="saveButton">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    );
}

export default UpdateParty;